export default __webpack_public_path__ + "static/11-7dcc696f32b57f9d674ea650f1b1ac10.png";